import chatbotRequest from '../http'
import type { ChannelListReq, ChannelListRes } from '../types/getChannelList'

export function getChannelListApi(data: ChannelListReq): Promise<ChannelListRes> {
  return chatbotRequest<ChannelListRes, ChannelListReq, ChannelListRes>({
    url: '/api/channel/list',
    method: 'post',
    data,
  })
}
